import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { FLUXO_PARCERIAS } from './constants/fluxo-parcerias/parcerias-simplificado.const';
import { APLICACAO_ROTAS_TRADICIONAL } from '../../constants/aplicacao-rotas-tradicional.const';
import { LogsService } from '../logs/logs.service';
import { enumTipoFluxoProposta } from '../../constants/tipo-proposta-fluxo.enum';
import { ApiResponseProposta } from 'src/app/abertura-conta/pages/tradicional/proponentes/hub-proponentes/models/proposta-idpessoa-response.interface';
import { StateProposta } from './interface/state-proposta.interface';
import { AtualizarEstadoPropostaResponse } from '../../models/atualizar-estado-proposta-response.interface';

@Injectable({
  providedIn: 'root'
})
export class StatesService {

  public stateProposta: StateProposta = {
    idProposta: '',
    state: 17,
    rotas: [],
    statusPreenchimento: false,
    tipoFluxoParcerias: false,
  };

  public isNovoCotitular = signal<{ novoCotitular: boolean, dadosMinimosPreenchidos: boolean } | null>(null);

  public downloadPac = signal<{ idProposta: string, idProponente: string, tipoProponente: string } | null>(null);

  public disabledFooter = signal<boolean>(false);

  public buttonVoltarON = signal<boolean>(true);

  public ButtonCancelarPropostaON = signal<boolean>(true);

  public cesData = signal<AtualizarEstadoPropostaResponse | null>(null);

  /* responsavel por capturar e observar a rota atual */
  private getRouterSubSubject = new BehaviorSubject<string>('');

  public getRoute$: Observable<string> = this.getRouterSubSubject.asObservable();

  /* responsavel por capturar e observar o estado atual da proposta  */
  private getStatePropostaSubSubject = new BehaviorSubject<{ status: number }>({ status: 0 });

  public getStateProposta$: Observable<{ status: number }> = this.getStatePropostaSubSubject.asObservable();

  /* responsavel por capturar e observar   o estado do preenchimento da atual tela e proposta */
  private getStatePreenchimentoSubSubject = new BehaviorSubject<{ status: boolean }>({ status: false });

  public getStatePreenchimento$: Observable<{ status: boolean }> = this.getStatePreenchimentoSubSubject.asObservable();

  /* reponsavel por realizar um set de titulo e subtitulo no aside caso você precise de um alternativo */
  public setTextTiutloSubtituloSubSubject = new BehaviorSubject<any>(null);

  public setTextTiutloSubtitulo$: Observable<any> = this.setTextTiutloSubtituloSubSubject.asObservable();

  /* responsavel por colocar imagens no aside */
  public setAsideImagemSubSubject = new BehaviorSubject<string>('');

  public setAsideImagem$: Observable<string> = this.setAsideImagemSubSubject.asObservable();

  /* responsavel por colocar as informacoes de CPF e nome do usuario no header */
  public getdadosUsuarioHeaderSubSubject = new BehaviorSubject<{ nome: string | null, cpf: string | null }>({ nome: null, cpf: null });

  public getdadosUsuarioHeader$: Observable<{ nome: string | null, cpf: string | null }> = this.getdadosUsuarioHeaderSubSubject.asObservable();

  /* responsavel por observar o evento "salvar dados" e emitir o valor true para que seja salvo as informacoes */
  public setSalvarDadosFooterSubSubject = new BehaviorSubject<boolean | null>(null);

  public setSalvarDadosFooter$: Observable<boolean | null> = this.setSalvarDadosFooterSubSubject.asObservable();

  /* reponsavel por emitir o valor de navegacao para a proxima rota ou anterior sem clicar*/
  public setNavegacaoFooterSubSubject = new BehaviorSubject<string | null>(null);

  public setNavegacaoFooter$: Observable<string | null> = this.setNavegacaoFooterSubSubject.asObservable();

  constructor(
    private router: Router,
    private logsService: LogsService,
  ) {
    this.getCurrentRoute();
  }

  /* pega a rota atual */
  private getCurrentRoute(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd | any) => {
      this.getRouterSubSubject.next(event.urlAfterRedirects);

    });
  }

  /* metodo responsavel por atualizar o titulo e subtitulo do aside */
  public upldateStatePreenchimento(status: boolean): void {
    this.stateProposta.statusPreenchimento = status;
    this.getStatePreenchimentoSubSubject.next({ status });
  }

  /* metodo chamado no lista-proposta no qual recebe as informacoes do proponente e da proposta
    caso nao possua envia para a tela de erro generico, caso sim ele avalia se a proposta e parcerias
    ou tradicional e encaminha para o fluxo
  */
  public setFluxoProposta(dadosProposta: ApiResponseProposta): void {
    if (!dadosProposta) {
      this.router.navigate([APLICACAO_ROTAS_TRADICIONAL.error.rota]);
      this.logsService.logError('Usuario encaminhado para tela de erro, avaliar proposta');
      return;
    }

    this.stateProposta.tipoFluxoParcerias =
      dadosProposta.tipoProposta === enumTipoFluxoProposta.FLUXO_PARCERIA;

    this.logsService.fluxo = this.stateProposta.tipoFluxoParcerias ? 'parcerias' : 'tradicional';
    this.stateProposta.idProposta = dadosProposta.codigoIdentificacaoProposta;
    this.logsService.logAppStart();

    if (this.stateProposta.tipoFluxoParcerias) {
      this.stateProposta.rotas = FLUXO_PARCERIAS;
    }

  }

  public setImageAside(urlImage: string): void {
    this.setAsideImagemSubSubject.next(urlImage);
  }

  public navigateToProposta(pathNavigate: string): void {
    this.router.navigate([pathNavigate]);
  }

}
